import Box from '@mui/material/Box'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import ProjectDetailsComponent from './ProjectDetailsComponent'

interface ProjectsListProps {}

const EngineerProjectsListComponent: React.FC<ProjectsListProps> = ({}) => {
  const assignedProjects = useSelector(
    (state: RootState) => state.review.assignedProjects,
  )

  return (
    <Box
      sx={{
        display: 'inline-block',
        overflowY: 'auto',
        boxSizing: 'border-box',
        ml: '0.75rem',
        mt: '0.75rem',
      }}
    >
      {assignedProjects.map((project, index) => (
        <Box
          key={index}
          sx={{
            display: 'inline-block',
            width: '31.9%',
            pr: '1rem',
          }}
        >
          <ProjectDetailsComponent project={project} />
        </Box>
      ))}
    </Box>
  )
}

export default EngineerProjectsListComponent
